export const SCHEMA_TYPE = 'https://schema.org';
export const TYPE_KEY = '@type';
export const CONTEXT_KEY = '@context';
export const ITEM_PROP_NAME = 'name';
export const ITEM_PROP_POSITION = 'position';
export const ITEM_PROP_ITEM = 'item';
